import React, { Component } from 'react';
import update from 'immutability-helper';
import Loading from '../../Components/Loading.js';
import FormCheckbox from '../../Fields/FormCheckbox.js';
import { getHomepageInfo, getPersonDeontologies, postPersonDeontologies, deleteDeactivateAccount } from '../../Api/UserActions.js';
import { getTranslation } from '../../Utilities/GetTranslation.js';
import { getDateString, getJsonDate } from '../../Utilities/JsonFunctions.js';

declare var Cookies;
declare var globalSns;

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.saveData = this.saveData.bind(this);
        this.deleteAccount = this.deleteAccount.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getPersonDeontologies((data) => {
            this.setState({
                personDeontologies: data
            });
        });        
        getHomepageInfo((data) => {
            this.setState({
                homepageInfo: data
            });
        });
    }

    saveData(deontologies) {
        postPersonDeontologies(deontologies.vacature, deontologies.carriereInfo, deontologies.news, deontologies.cvOnline, (data) => {});
    }

    deleteAccount() {
        if (window.confirm(getTranslation("sns.webparts.settings.deleteaccount.confirm"))) {
            deleteDeactivateAccount((ok) => {
                if (ok) {
                    Cookies.remove("namezzz");
                    window.location = "/";
                }
            });
        }

    }

    onSelectChange(e) {
        var deontologies = update(this.state.personDeontologies, {[e.target.id]: {$set: e.target.checked}});
        this.setState({
            personDeontologies: deontologies
        });
        this.saveData(deontologies); // = Autosave
    } 

    render() {
        if (this.state.homepageInfo == null || this.state.personDeontologies == null) {
            return (
                <Loading/>
            );
        }

        var registeredDate = this.state.homepageInfo.registeredDate;

        return (
            <div className="registration">
                <div className="EditingFormTable table">

                    <h4 className="legend-title">{getTranslation("sns.webparts.confirmation.newsletters")}</h4>

                    <FormCheckbox id="vacature"
                        text={getTranslation("sns.webparts.confirmation.vacature")}
                        value={this.state.personDeontologies.vacature}
                        onChange={this.onSelectChange} />                
                    <FormCheckbox id="carriereInfo"
                        text={getTranslation("sns.webparts.confirmation.carriereinfo")}
                        value={this.state.personDeontologies.carriereInfo}
                        onChange={this.onSelectChange} />
                    <FormCheckbox id="news"
                        text={getTranslation("sns.webparts.confirmation.news")}
                        value={this.state.personDeontologies.news}
                        onChange={this.onSelectChange} />

                    <h4 className="legend-title">{getTranslation("sns.webparts.settings.registration")}</h4>

                    <FormCheckbox id="cvOnline"
                        text={getTranslation("sns.webparts.settings.cvonline")}
                        value={this.state.personDeontologies.cvOnline}
                        onChange={this.onSelectChange} />

                    <div className="tr">
                        <div className="FieldLabel td">
                            <label>
                                {getTranslation("sns.webparts.settings.registereddate").replace(/{0\}/, getDateString(getJsonDate(registeredDate)))}
                            </label>
                        </div>
                        <div className="EditingFormValueCell td">
                            <button type="button" className="FormButton btn btn-primary btn-sm" onClick={this.deleteAccount}>
                                <i className="fa fa-trash" aria-hidden="true"></i>&nbsp;
                                {getTranslation("sns.webparts.settings.deleteaccount")}
                            </button>
                        </div>                    

                    </div> 

                </div>
            </div>
        );  
    }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/Components/Pages/Settings.js